/* Evolved Elements Buyer's Report: Rule 4 spark animation, swipeable buy-box gallery, selection feedback. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TEAL = '#0E5A57', AMBER = '#C49746', INK = '#1A1714', SOFT = '#6B6560', RULE = '#D8D2C6', GROUND = '#F7F3EC';

  /* ---------------- Rule 4: thyroid spark -> liver conversion ---------------- */
  var LAYOUTS = {
    tall: { w: 340, h: 470, gland: [170, 78], liver: [170, 318], path: 'M170 122 C 120 180, 220 220, 170 272',
            meter: [40, 432, 260], gl: [170, 150, 'middle'], ll: [170, 382, 'middle'], fuel: [[268, 292], [282, 332], [262, 370]] },
    wide: { w: 680, h: 300, gland: [110, 120], liver: [470, 120], path: 'M170 120 C 250 60, 330 180, 405 120',
            meter: [60, 262, 560], gl: [110, 196, 'middle'], ll: [470, 196, 'middle'], fuel: [[572, 70], [600, 120], [572, 170]] }
  };
  function svg(L) {
    var g = L.gland, v = L.liver, m = L.meter;
    return '<svg class="ee-s4svg" viewBox="0 0 ' + L.w + ' ' + L.h + '" role="img" aria-labelledby="ee-s4t ee-s4d" xmlns="http://www.w3.org/2000/svg">' +
      '<title id="ee-s4t">Thyroid gives the spark, the liver converts it</title>' +
      '<desc id="ee-s4d">Illustration: sparks leave the thyroid gland, travel to the liver, and turn into usable energy. With liver nutrients added, the liver converts sparks faster and the energy bar fills sooner.</desc>' +
      '<defs><radialGradient id="ee-s4glow"><stop offset="0" stop-color="#FFD98A"/><stop offset=".45" stop-color="' + AMBER + '"/><stop offset="1" stop-color="' + AMBER + '" stop-opacity="0"/></radialGradient>' +
      '<radialGradient id="ee-s4glow2"><stop offset="0" stop-color="#B2FCE4"/><stop offset=".45" stop-color="' + TEAL + '"/><stop offset="1" stop-color="' + TEAL + '" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="ee-s4bar" x1="0" x2="1"><stop offset="0" stop-color="' + AMBER + '"/><stop offset="1" stop-color="' + TEAL + '"/></linearGradient></defs>' +
      // path
      '<path d="' + L.path + '" fill="none" stroke="' + RULE + '" stroke-width="10" stroke-linecap="round"/>' +
      '<path class="ee-s4path" d="' + L.path + '" fill="none" stroke="' + AMBER + '" stroke-opacity=".35" stroke-width="2" stroke-dasharray="4 8" stroke-linecap="round"/>' +
      // thyroid gland (butterfly)
      '<g class="ee-s4gland" transform="translate(' + g[0] + ' ' + g[1] + ')">' +
        '<circle r="58" fill="url(#ee-s4glow)" opacity=".28" class="ee-s4halo"/>' +
        '<path d="M-6 -4 C -20 -44, -62 -40, -58 0 C -56 34, -22 40, -8 18 Z" fill="#E9B7A6" stroke="' + INK + '" stroke-width="1.5"/>' +
        '<path d="M6 -4 C 20 -44, 62 -40, 58 0 C 56 34, 22 40, 8 18 Z" fill="#E9B7A6" stroke="' + INK + '" stroke-width="1.5"/>' +
        '<rect x="-10" y="-4" width="20" height="20" rx="6" fill="#DFA592" stroke="' + INK + '" stroke-width="1.5"/>' +
        '<path d="M-38 -6 q8 -8 16 0 M22 -6 q8 -8 16 0" stroke="' + INK + '" stroke-opacity=".35" fill="none" stroke-width="1.2"/>' +
      '</g>' +
      '<text x="' + L.gl[0] + '" y="' + L.gl[1] + '" text-anchor="' + L.gl[2] + '" class="ee-s4lbl">01 · THYROID GIVES THE SPARK</text>' +
      '<text x="' + L.gl[0] + '" y="' + (L.gl[1] + 18) + '" text-anchor="' + L.gl[2] + '" class="ee-s4sub">makes the storage hormone (T4)</text>' +
      // liver
      '<g class="ee-s4liver" transform="translate(' + v[0] + ' ' + v[1] + ')">' +
        '<circle r="64" fill="url(#ee-s4glow2)" opacity="0" class="ee-s4halo2"/>' +
        '<path d="M-62 -6 C -60 -38, -14 -46, 30 -38 C 58 -33, 66 -14, 60 2 C 52 24, 18 30, -8 36 C -34 42, -64 26, -62 -6 Z" fill="#9C4A3C" stroke="' + INK + '" stroke-width="1.5"/>' +
        '<path d="M-10 -40 C -4 -18, -6 10, -14 34" stroke="' + INK + '" stroke-opacity=".35" fill="none" stroke-width="1.2"/>' +
        '<g class="ee-s4gear" transform="translate(18 -2)"><circle r="13" fill="none" stroke="#F7E3D8" stroke-width="3" stroke-dasharray="5 4"/><circle r="4" fill="#F7E3D8"/></g>' +
      '</g>' +
      '<text x="' + L.ll[0] + '" y="' + L.ll[1] + '" text-anchor="' + L.ll[2] + '" class="ee-s4lbl">02 · LIVER CONVERTS IT</text>' +
      '<text x="' + L.ll[0] + '" y="' + (L.ll[1] + 18) + '" text-anchor="' + L.ll[2] + '" class="ee-s4sub">into the active form (T3)</text>' +
      // liver fuel chips
      L.fuel.map(function (p, i) {
        var t = ['Fe', 'A', 'Se'][i], n = ['Heme iron', 'Retinol', 'Selenium'][i];
        return '<g class="ee-s4fuel" data-i="' + i + '" transform="translate(' + p[0] + ' ' + p[1] + ')"><title>' + n + ' from beef liver</title><circle r="15" fill="' + GROUND + '" stroke="' + TEAL + '" stroke-width="2"/><text y="5" text-anchor="middle" class="ee-s4chip">' + t + '</text></g>';
      }).join('') +
      // meter
      '<text x="' + m[0] + '" y="' + (m[1] - 12) + '" class="ee-s4sub">Usable energy</text>' +
      '<text x="' + (m[0] + m[2]) + '" y="' + (m[1] - 12) + '" text-anchor="end" class="ee-s4sub ee-s4pct">0%</text>' +
      '<rect x="' + m[0] + '" y="' + m[1] + '" width="' + m[2] + '" height="14" rx="7" fill="#fff" stroke="' + RULE + '"/>' +
      '<rect class="ee-s4fill" x="' + m[0] + '" y="' + m[1] + '" width="0" height="14" rx="7" fill="url(#ee-s4bar)"/>' +
      '<g class="ee-s4sparks"></g>' +
      '</svg>';
  }

  var viz = null;
  function mountViz() {
    var slot = document.querySelector('.ee-s4slot');
    if (!slot || slot.querySelector('.ee-s4viz')) return;
    // The page runtime owns the slot; the animation lives in a child it never renders.
    var host = viz && viz.host && !viz.host.isConnected ? viz.host : document.createElement('div');
    host.className = 'ee-s4viz' + (viz && viz.liver ? ' is-liver' : '');
    slot.appendChild(host);
    if (host.__ee) { if (viz && !reduce && viz.visible && !viz.raf) { viz.last = performance.now(); viz.raf = requestAnimationFrame(tick); } return; }
    host.__ee = 1;
    host.setAttribute('aria-label', 'Animated illustration: thyroid gives the spark, the liver converts it');
    host.innerHTML =
      '<div class="ee-s4toggle" role="group" aria-label="Compare"><button type="button" data-s4="0" aria-pressed="true">Thyroid alone</button><button type="button" data-s4="1" aria-pressed="false">Thyroid + Beef Liver</button></div>' +
      '<div class="ee-s4stage">' + svg(LAYOUTS.tall).replace('class="ee-s4svg"', 'class="ee-s4svg ee-s4tall"') + svg(LAYOUTS.wide).replace('class="ee-s4svg"', 'class="ee-s4svg ee-s4wide"').replace(/id="ee-s4(t|d|glow2?|bar)"/g, 'id="ee-s4$1w"').replace(/url\(#ee-s4(glow2?|bar)\)/g, 'url(#ee-s4$1w)').replace('aria-labelledby="ee-s4t ee-s4d"', 'aria-labelledby="ee-s4tw ee-s4dw"') + '</div>' +
      '<p class="ee-s4note" aria-live="polite"></p>';
    viz = { host: host, liver: false, fill: 0, sparks: [], last: 0, spawn: 0, visible: false, raf: 0 };
    host.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s4]'); if (!b) return;
      setLiver(b.getAttribute('data-s4') === '1');
    });
    setLiver(false, true);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        viz.visible = en[0].isIntersecting;
        if (viz.visible && !reduce && !viz.raf) { viz.last = performance.now(); viz.raf = requestAnimationFrame(tick); }
        // Auto-demo: after a few seconds in view, show the liver version once.
        if (viz.visible && !viz.demoed && !reduce) { viz.demoed = 1; setTimeout(function () { if (!viz.touched) setLiver(true); }, 4200); }
      }, { threshold: 0.25 }).observe(host);
    }
    if (reduce) drawStatic();
  }
  function active() { var s = viz.host.querySelectorAll('.ee-s4svg'); return getComputedStyle(s[0]).display !== 'none' ? s[0] : s[1]; }
  function setLiver(on, init) {
    if (!init) viz.touched = 1;
    viz.liver = on; viz.fill = 0;
    viz.host.classList.toggle('is-liver', on);
    viz.host.querySelectorAll('[data-s4]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-s4') === '1') === on)); });
    viz.host.querySelector('.ee-s4note').textContent = on
      ? 'With liver nutrients on board (heme iron, retinol, selenium), the liver converts each spark faster, so usable energy builds sooner.'
      : 'Thyroid alone: the gland supplies the spark and the liver converts it at its own pace.';
    if (reduce) drawStatic();
  }
  function drawStatic() {
    viz.host.querySelectorAll('.ee-s4svg').forEach(function (s) {
      var p = s.querySelector('.ee-s4path'), len = p.getTotalLength(), g = s.querySelector('.ee-s4sparks'), out = '';
      [0.2, 0.45, 0.7].forEach(function (f) { var pt = p.getPointAtLength(len * f); out += '<circle cx="' + pt.x + '" cy="' + pt.y + '" r="6" fill="url(#' + (s.classList.contains('ee-s4wide') ? 'ee-s4gloww' : 'ee-s4glow') + ')"/>'; });
      g.innerHTML = out;
      setFill(s, viz.liver ? 0.85 : 0.5);
    });
  }
  function setFill(s, f) {
    var m = s.classList.contains('ee-s4wide') ? LAYOUTS.wide.meter : LAYOUTS.tall.meter;
    s.querySelector('.ee-s4fill').setAttribute('width', Math.max(0, Math.min(1, f)) * m[2]);
    s.querySelector('.ee-s4pct').textContent = Math.round(Math.min(1, f) * 100) + '%';
  }
  function tick(t) {
    viz.raf = 0;
    if (!viz.visible || !viz.host.isConnected) return;
    var dt = Math.min(64, t - viz.last); viz.last = t;
    var s = active(), p = s.querySelector('.ee-s4path'), len = p.getTotalLength(), g = s.querySelector('.ee-s4sparks');
    var speed = viz.liver ? 0.00042 : 0.00030, hold = viz.liver ? 220 : 1100, rate = viz.liver ? 420 : 620;
    viz.spawn -= dt;
    if (viz.spawn <= 0) { viz.sparks.push({ u: 0, hold: 0, el: null }); viz.spawn = rate; }
    var html = '';
    viz.sparks = viz.sparks.filter(function (k) {
      if (k.u < 1) { k.u = Math.min(1, k.u + dt * speed); }
      else { k.hold += dt; if (k.hold >= hold) { viz.fill = Math.min(1, viz.fill + (viz.liver ? 0.05 : 0.028)); pulse(s); return false; } }
      var pt = p.getPointAtLength(len * k.u), conv = k.u >= 1;
      html += '<circle cx="' + pt.x.toFixed(1) + '" cy="' + pt.y.toFixed(1) + '" r="' + (conv ? 9 : 7) + '" fill="url(#' + (s.classList.contains('ee-s4wide') ? (conv ? 'ee-s4glow2w' : 'ee-s4gloww') : (conv ? 'ee-s4glow2' : 'ee-s4glow')) + ')"/>';
      return true;
    });
    g.innerHTML = html;
    if (viz.fill >= 1) viz.fill = viz.liver ? 0.35 : 0.2; // loop the demo
    setFill(s, viz.fill);
    viz.raf = requestAnimationFrame(tick);
  }
  function pulse(s) {
    var h = s.querySelector('.ee-s4halo2'); if (!h) return;
    h.style.transition = 'none'; h.style.opacity = '.55';
    requestAnimationFrame(function () { h.style.transition = 'opacity .6s'; h.style.opacity = '0'; });
  }

  /* ---------------- Buy box: swipe gallery ---------------- */
  var rcur = 0, rraf = 0;
  function RT() { return document.querySelector('.ee-rgal-track'); }
  window.EE_RGAL = {
    go: function (i) {
      var t = RT(); if (!t || window.EE_RGAL._fromSwipe) return;
      var n = t.children.length; i = Math.max(0, Math.min(n - 1, i));
      rcur = i;
      var c = document.querySelector('.ee-rgal-count'); if (c) c.textContent = (i + 1) + ' / ' + n;
      var x = i * t.clientWidth;
      if (reduce || document.hidden) { t.scrollTo({ left: x, behavior: 'instant' }); return; }
      t.scrollTo({ left: x, behavior: 'smooth' });
      setTimeout(function () { var u = RT(); if (u && Math.abs(u.scrollLeft - x) > 4) u.scrollTo({ left: x, behavior: 'instant' }); }, 700);
    },
    step: function (d) { window.EE_RGAL.go(rcur + d); }
  };
  function rsync() {
    rraf = 0;
    var t = RT(); if (!t) return;
    var n = t.children.length, i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    var c = document.querySelector('.ee-rgal-count'); if (c) c.textContent = (i + 1) + ' / ' + n;
    if (i === rcur) return;
    rcur = i;
    var thumbs = document.querySelectorAll('#buy-box ul button[aria-label]');
    if (thumbs[i]) { window.EE_RGAL._fromSwipe = true; thumbs[i].click(); window.EE_RGAL._fromSwipe = false; }
  }
  // Sync thumbnails only once the swipe or programmatic scroll has settled. Syncing mid-animation
  // clicked intermediate thumbnails, which started new scrolls and made the images flip on their own.
  var rsettle = 0;
  document.addEventListener('scroll', function (e) {
    if (!(e.target && e.target.classList && e.target.classList.contains('ee-rgal-track'))) return;
    clearTimeout(rsettle); rsettle = setTimeout(rsync, 140);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ee-rgal-prev,.ee-rgal-next'); if (!b) return;
    window.EE_RGAL.step(b.classList.contains('ee-rgal-next') ? 1 : -1);
  });
  document.addEventListener('keydown', function (e) {
    if (!e.target.classList || !e.target.classList.contains('ee-rgal-track')) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); window.EE_RGAL.step(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); window.EE_RGAL.step(-1); }
  });

  /* ---------------- Buy box: forward / back confirmation ---------------- */
  var lastTotal = null;
  function money(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }
  function watchSummary() {
    var tot = document.querySelector('#buy-box .ee-glow');
    if (!tot || tot.__ee) return;
    tot.__ee = 1;
    lastTotal = money(tot.textContent);
    new MutationObserver(function () {
      var now = money(tot.textContent);
      if (now === null || now === lastTotal) return;
      var dir = lastTotal === null || now > lastTotal ? 'fwd' : 'back';
      lastTotal = now;
      var box = tot.closest('dl'); if (!box) return;
      var chip = document.querySelector('.ee-sumchip');
      box.classList.remove('ee-sum-fwd', 'ee-sum-back'); void box.offsetWidth;
      box.classList.add('ee-sum-' + dir);
      if (chip) {
        chip.textContent = dir === 'fwd' ? '✓ Added · order updated' : '↩ Changed · order updated';
        chip.classList.remove('is-on'); void chip.offsetWidth; chip.classList.add('is-on');
      }
    }).observe(tot, { childList: true, characterData: true, subtree: true });
  }


  // Warm every slide once the gallery is close to the screen, so swiping never shows a blank frame.
  function warm(sel) {
    var g = document.querySelector(sel); if (!g || g.__warm) return; g.__warm = 1;
    var go = function () { g.querySelectorAll('img[loading=lazy]').forEach(function (i) { i.loading = 'eager'; }); };
    if (!('IntersectionObserver' in window)) return go();
    var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { o.disconnect(); go(); } }, { rootMargin: '600px 0px' });
    o.observe(g);
  }
  function boot() {
    mountViz(); watchSummary();
    warm('.ee-rgal');
    var c = document.querySelector('.ee-rgal-count'), t = RT();
    if (c && t && !c.__ee) { c.__ee = 1; c.textContent = '1 / ' + t.children.length; }
  }
  function start() {
    boot();
    var q = 0;
    new MutationObserver(function () { if (!q) q = setTimeout(function () { q = 0; boot(); }, 250); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
